import type { ApiOrder } from '../types';

/**
 * Derives the customer-facing order code per §2.2:
 *   - take `externalId` (fall back to `id`)
 *   - strip hyphens
 *   - keep alphanumerics
 *   - take the last 5 characters
 *   - uppercase
 *
 * If the source string is empty or has no alphanumerics, returns "?????" -
 * the card can still render and the gap signals a malformed feed to QA.
 */
export function deriveOrderCode(order: Pick<ApiOrder, 'externalId' | 'id'>): string {
  const source = order.externalId.trim() !== '' ? order.externalId : order.id;
  if (!source) return '?????';
  const cleaned = source.replace(/-/g, '').replace(/[^a-zA-Z0-9]/g, '');
  if (cleaned.length === 0) return '?????';
  return cleaned.slice(-5).toUpperCase();
}

/**
 * "Guest" placeholder used when `title` is missing or blank (§2.2).
 */
export function deriveDisplayName(title: string | null | undefined): string {
  if (!title) return 'Guest';
  const trimmed = title.trim();
  return trimmed.length === 0 ? 'Guest' : trimmed;
}
